import { categories, featuredCategories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'Hoodies/Sweaters': 'https://readdy.ai/api/search-image?query=Two%20folded%20hoodies%20stacked%20neatly%20on%20a%20light%20oak%20wooden%20surface%2C%20one%20in%20heather%20gray%20the%20other%20in%20soft%20terracotta%2C%20visible%20knit%20texture%20and%20ribbed%20cuffs%2C%20top-down%20flatlay%20shot%20with%20soft%20morning%20light%20coming%20from%20upper%20left%20corner%20creating%20gentle%20raking%20shadows%20across%20the%20fabric%20folds%2C%20cozy%20minimalist%20aesthetic%2C%20neutral%20warm%20palette%20with%20subtle%20color%20contrast%2C%20Scandinavian%20interior%20photography%20style%2C%20clean%20and%20simple&width=600&height=450&seq=cat-hoodies-v2-12&orientation=landscape',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Three%20crisp%20white%20cotton%20t-shirts%20hanging%20neatly%20on%20minimal%20wooden%20hangers%20against%20a%20soft%20blush%20pink%20wall%2C%20diffused%20studio%20lighting%20from%20above%20creating%20even%20illumination%20without%20harsh%20shadows%2C%20visible%20fabric%20texture%20and%20clean%20seams%2C%20modern%20boutique%20display%20presentation%2C%20fresh%20and%20airy%20atmosphere%2C%20pastel%20blush%20and%20ivory%20color%20palette&width=600&height=450&seq=cat-tshirts-v2-13&orientation=landscape',
  Jackets: 'https://readdy.ai/api/search-image?query=A%20single%20structured%20olive%20green%20utility%20jacket%20draped%20over%20the%20back%20of%20a%20mid-century%20modern%20wooden%20chair%2C%20natural%20window%20light%20from%20the%20side%20casting%20soft%20shadows%2C%20visible%20stitching%20details%20and%20brass%20button%20hardware%2C%20warm%20earthy%20tones%2C%20editorial%20menswear%20photography%2C%20sophisticated%20casual%20styling%2C%20warm%20terracotta%20wall%20in%20background%20blurred%20out&width=600&height=450&seq=cat-jackets-v2-14&orientation=landscape',
  Accessories: 'https://readdy.ai/api/search-image?query=A%20curated%20arrangement%20of%20minimalist%20gold%20jewelry%20and%20a%20pair%20of%20tortoiseshell%20sunglasses%20laid%20out%20on%20raw%20travertine%20stone%2C%20natural%20sunlight%20creating%20warm%20highlights%20on%20the%20metal%20surfaces%2C%20one%20small%20ceramic%20dish%20holding%20a%20delicate%20chain%20necklace%2C%20clean%20composition%20with%20intentional%20spacing%2C%20warm%20stone%20and%20gold%20color%20palette%2C%20luxury%20accessories%20editorial%20photography%2C%20refined%20and%20modern&width=600&height=450&seq=cat-accessories-v2-15&orientation=landscape',
  Bags: 'https://readdy.ai/api/search-image?query=A%20structured%20cognac%20leather%20tote%20bag%20standing%20upright%20on%20a%20light%20marble%20countertop%2C%20soft%20natural%20daylight%20from%20a%20large%20window%20creating%20a%20gentle%20glow%20on%20the%20leather%20surface%2C%20visible%20grain%20texture%20and%20brass%20hardware%20details%2C%20a%20single%20dried%20palm%20leaf%20leaning%20against%20the%20bag%20for%20scale%20and%20styling%2C%20warm%20caramel%20and%20ivory%20tones%2C%20boutique%20window%20display%20photography%2C%20elegant%20minimal%20composition&width=600&height=450&seq=cat-bags-v2-16&orientation=landscape',
};

export default function CategorySection() {
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank');
    }
    e.target.value = '';
  };

  return (
    <section id="categories" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3 block">
              Browse Products
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
              Shop by Category
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            Explore our comprehensive Superbuy spreadsheet collections organized by category. Each link takes you directly to the latest curated product lists with verified seller information.
          </p>
        </div>

        <div className="mb-10">
          <div className="relative max-w-md">
            <select
              onChange={handleSelect}
              aria-label="Browse product categories"
              className="w-full appearance-none bg-background-50 border border-background-300 rounded-xl px-5 py-4 pr-12 text-sm font-medium text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
            >
              <option value="">Select a category to browse...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                idx === 0
                  ? 'lg:row-span-2 bg-foreground-900'
                  : 'bg-background-50'
              }`}
            >
              {idx === 0 ? (
                <div className="relative h-full min-h-[400px] flex flex-col justify-end p-6">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20stunning%20pair%20of%20retro%20chunky%20sneakers%20in%20cream%20and%20sage%20green%20colorway%20shot%20from%20a%20low%20angle%20on%20a%20rough%20concrete%20surface%2C%20dramatic%20afternoon%20sunlight%20casting%20long%20angular%20shadows%20behind%2C%20urban%20street%20style%20photography%2C%20visible%20textured%20sole%20and%20layered%20upper%20details%2C%20worn-in%20authentic%20look%20with%20slight%20distressing%20on%20the%20midsole%2C%20warm%20golden%20hour%20light%20bathing%20the%20scene%2C%20editorial%20sneaker%20culture%20photography%2C%20gritty%20yet%20polished%20aesthetic&width=800&height=1000&seq=cat-shoes-featured-v2-17&orientation=portrait"
                    alt="Superbuy Spreadsheet Shoes collection"
                    className="absolute inset-0 w-full h-full object-cover object-top opacity-70"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-900 via-foreground-900/60 to-transparent"></div>
                  <div className="relative z-10">
                    <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">
                      {cat.name}
                    </h3>
                    <p className="text-sm text-background-50/70 mb-3 line-clamp-2">
                      {cat.description}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-300">
                      {cat.items.toLocaleString()} items
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                    </span>
                  </div>
                </div>
              ) : (
                <div className="p-5">
                  <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden mb-4 bg-background-100">
                    <img
                      src={categoryImages[cat.name]}
                      alt={`Superbuy Spreadsheet ${cat.name} products`}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider bg-background-50/90 backdrop-blur-sm text-foreground-700 px-3 py-1.5 rounded-full">
                        <i className="ri-star-line"></i>
                        Featured
                      </span>
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                    {cat.description}
                  </p>
                  <span className="text-xs font-medium text-foreground-400">
                    {cat.items.toLocaleString()} items
                  </span>
                </div>
              )}
            </a>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 bg-background-50 hover:bg-background-200 rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-all duration-200 cursor-pointer whitespace-nowrap border border-background-200/60 hover:border-primary-200"
            >
              <span className="w-7 h-7 flex items-center justify-center">
                <i className={`${cat.icon} text-primary-500 text-sm`}></i>
              </span>
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}